<template>
<!--    <label @click="onInputClick" :class="style_class">-->
    <label :class="style_class">
        <slot :onInputClick="onInputClick"></slot>
        <input :disabled="disabled" @change="inputFile" type="file" accept="image/jpeg,image/jpg,image/png,image/webp"
               :multiple="multiple"
               style="visibility: hidden; position: absolute; height: 0" ref="fileInput">
    </label>
</template>

<script>
    import Vue from 'vue';
    import Compressor from 'compressorjs';

    export default {
        name: "ImageInput",
        props: {
            disabled: {
                default: false,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            style_class: {
                default: null,
            },
            quality: {
                type: Number,
                default: 0.8,
            }
        },
        data() {
            return {
                input_value: '',
            }
        },
        methods: {
            onInputClick() {
                this.$refs.fileInput.click();
            },
            inputFile(e) {
                const vm = this;
                let files = e.target.files;
                let end_index = files.length - 1;
                vm.$emit('start');
                Array.from(files).forEach((file, index) => {

                    if (!file) {
                        return;
                    }

                    new Compressor(file, {
                        maxWidth: 807,
                        maxHeight: 807,
                        quality: vm.quality,
                        convertSize: 200000,
                        success(result) {
                            vm.$emit('success', result);
                            if (index === end_index) {
                                vm.$emit('complete');
                            }
                        },
                        error() {
                            Vue.toasted.show(`<div>ОШИБКА<br>Не удалось сжать изображение.<br>Описание: Кажется у Вас устарел браузер.</div>`, {
                                type: 'error',
                                position: 'bottom-center',
                                action: {
                                    text: 'Ок',
                                    onClick: (e, toastObject) => {
                                        toastObject.goAway(0);
                                    }
                                },
                            });
                        },
                    });
                });
                this.$refs.fileInput.value = ''
            },
        },
    }
</script>

<style scoped>
    label {
        margin-bottom: 0;
    }
</style>